
import React, { useContext, useEffect, useState, } from 'react';
import ARSTabs from './ArsTabs';
import { HexagonIcon, RulesIcon, SubModelIcon } from 'assests/GmsIcons';
import ARSPageHeader from './ArsPageHeader';
import { getModelData, updateRecommenderModel } from '../ARSServices/ARSServices';
import { toast } from 'react-toastify';
import CompatioLoader from 'Components/Common/components/CompatioLoader';
import ArsDefineModel from './ArsDefineModel';
import PromotionModal from './PromotionModal';
import { ArsContext } from '../Contexts/ArsContext';
import { useHistory } from 'react-router-dom';
import { RecommenderLogsResponse, TSetPriorityMode } from '../Types';

const ArsModelComponent = (props: any) => {
    const { params } = props.match;
    const { modelId } = params;
    const [loading, setLoading] = useState(false)
    const [showPromote, setShowPromote] = useState<boolean>(false)
    const { industryId, model, setModel, activeSubmodelIndex, setActiveSubmodelIndex } = useContext(ArsContext);
    const history = useHistory();

    useEffect(() => {
        if (modelId) { getModel(); if (activeSubmodelIndex !== 0) setActiveSubmodelIndex(0) }
    }, [modelId])


    const getModel = async () => {
        try {
            setLoading(true)
            const res = await getModelData(modelId)
            if (res?.done) {
                setModel(res?.data)
            }
        } catch (error) {
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }

    const tabLabels = [
        { label: "Summary", icon: <SubModelIcon />, disable: true },
        { label: "Model", icon: <SubModelIcon />, disable: false },
        { label: "Rules", icon: <RulesIcon />, disable: true },
        { label: "AB Testing", icon: <HexagonIcon />, disable: true },
        { label: "Analytics", icon: <SubModelIcon />, disable: true },
        { label: "UI Builder", icon: <HexagonIcon />, disable: true },
    ]

    const [activeTab, setActiveTab] = useState<number>(1)


    const handleTabClick = (index: number) => setActiveTab(index);


    const updateSetModePriority = (setModePriority: TSetPriorityMode[], submodelId: string) => {
        setModel((prev: any) => {
            const newObj = { ...prev };

            if (newObj?.submodel && newObj.submodel.length > 0) {
                const updatedSubmodels = [...newObj.submodel];
                const submodelIndex = updatedSubmodels.findIndex(
                    (submodel) => submodel.submodel_id === submodelId
                );
                if (submodelIndex !== -1) {
                    updatedSubmodels[submodelIndex] = {
                        ...updatedSubmodels[submodelIndex],
                        setModePriority
                    };
                }
                newObj.submodel = updatedSubmodels;
            }
            return newObj;
        });
    };

    const togglePromoteModal = () => {
        setShowPromote(prev => !prev)
    }
    const promotionHandler = () => {

    }

    function validateMinNumProducts(setModePriority: TSetPriorityMode[]): boolean {
        return setModePriority.every(mode => mode.minNumProducts > 0);
    }

    const updateModel = async (): Promise<void> => {
        if (!industryId) return;

        try {
            // Validate that all mode titles are non-empty
            const hasValidTitles = model?.submodel?.every(x =>
                x.setModePriority.every(mode => mode.title?.trim().length > 0)
            );

            if (!hasValidTitles) {
                toast.error("All mode titles are required. Please ensure each mode has a valid title.");
                return;
            }

            // Validate minimum number of products
            const hasValidProductCount = model?.submodel?.every(x =>
                validateMinNumProducts(x?.setModePriority)
            );

            if (!hasValidProductCount) {
                toast.warn("The minimum number of products must be greater than zero.");
                return;
            }

            const res = await updateRecommenderModel(model as RecommenderLogsResponse);

            if (res?.done) {
                toast.success("Model updated successfully");
                history.replace('/gms/ars');
            } else {
                toast.error(res?.message ?? "Failed to update model");
            }
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : "Failed to update model";
            toast.error(errorMessage);
        }
    };

    return (
        loading ? <CompatioLoader /> :
            <React.Fragment>
                <ARSPageHeader model={model as RecommenderLogsResponse} onSave={updateModel}
                    togglePromoteModal={togglePromoteModal}
                />
                <div className='tw-flex tw-justify-center tw-border-b tw-border-t tw-border-solid tw-border-lightgray-200'>
                    <ARSTabs tabLabels={tabLabels} activeTab={activeTab} onTabClick={handleTabClick} />
                </div>

                {activeTab === 1 ? <ArsDefineModel model={model} setModel={setModel} updateSetModePriority={updateSetModePriority} /> : null}

                {activeTab === 2 ? <label className={`tw-text-black tw-text-[24px] tw-font-semibold`}>{"Coming Soon....."}</label>
                    : null}
                <PromotionModal showModal={showPromote} closeModal={togglePromoteModal} onConfirm={promotionHandler} />
            </React.Fragment>
    );
}

export default ArsModelComponent;